module.exports = __webpack_public_path__ + "img/itx-file-type-vsd.984ba3d0.svg";